import { Button, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import TRACKING_IDS from 'tracking-ids';

import type { SessionTimeoutKind } from 'contexts/ui/useSessionTimeoutWarning';
import type { ReactNode } from 'react';

// Mantine's orange, which is --klue-signal-urgent in design/tokens.yaml. The toast's accent bar
// and its button both use it.
export const SESSION_TIMEOUT_COLOR = 'orange';

type SessionTimeoutMessageProps = {
  kind: SessionTimeoutKind;
  remainingTime: string;
  onAction: () => void;
};

/**
 * Body of the warning that SessionTimeoutNotifier shows: the time left and one button. For an
 * idle timeout the button keeps the session alive; for an absolute timeout it signs out now.
 */
export function SessionTimeoutMessage({
  kind,
  remainingTime,
  onAction,
}: SessionTimeoutMessageProps): ReactNode {
  const { t } = useTranslation(['Session']);

  return (
    <Stack gap="sm">
      <Text size="sm">
        {t(`Session:timeout.${kind}.message`, { remainingTime })}
      </Text>
      <Group justify="flex-end">
        <Button
          size="xs"
          color={SESSION_TIMEOUT_COLOR}
          onClick={onAction}
          data-tracking-id={TRACKING_IDS.hatch.sessionTimeout[kind]}
        >
          {t(`Session:timeout.${kind}.button`)}
        </Button>
      </Group>
    </Stack>
  );
}
